import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Condition, User } from "../models";
import { TableViewConfig } from "../models/view-config/table-view-config.model";
import { ViewButton } from "../models/view-config/view-button.model";
import { ViewColumnField } from "../models/view-config/view-column-field.model";
import { ViewColumnGroup } from "../models/view-config/view-column-group.model";
import { ViewCondition } from "../models/view-config/view-condition.model";
import { ViewConfig } from "../models/view-config/view-config.model";
import { ViewFormula } from "../models/view-config/view-formula.model";
import { ViewImageButton } from "../models/view-config/view-image-button.model";
import { AdminService, ApiService, AuthService, CalendarService, ConditionService, DialogService, FieldService, FormulaService, MessagingService, MetadataService, ModalService, SessionService, TranslatorService } from "../services";

export abstract class DataTableAdapter {
    public serviceCollection: any = {}
    //#region Services
    public conditionService: ConditionService;
    public translatorService: TranslatorService;
    public fieldService: FieldService;
    public metadataService: MetadataService;
    public formulaService: FormulaService;
    public authService: AuthService;
    public calendarService: CalendarService;
    public sessionService: SessionService;
    public ngbModal: NgbModal;
    public ngbActiveModal: NgbActiveModal;
    public modalService: ModalService;
    public dialogService: DialogService;
    public apiService: ApiService;
    public messagingService: MessagingService;
    public adminService: AdminService;
    //#endregion
    public is_loading_data: boolean = false;

    constructor(view: string, customParameters: any) {
        this.datatable_view = view;
        this.serviceCollection = customParameters;
        if (customParameters['conditionService']) this.conditionService = customParameters['conditionService'];
        if (customParameters['translatorService']) this.translatorService = customParameters['translatorService'];
        if (customParameters['fieldService']) this.fieldService = customParameters['fieldService'];
        if (customParameters['metadataService']) this.metadataService = customParameters['metadataService'];
        if (customParameters['formulaService']) this.formulaService = customParameters['formulaService'];
        if (customParameters['authService']) this.authService = customParameters['authService'];
        if (customParameters['calendarService']) this.calendarService = customParameters['calendarService'];
        if (customParameters['sessionService']) this.sessionService = customParameters['sessionService'];
        if (customParameters['ngbModal']) this.ngbModal = customParameters['ngbModal'];
        if (customParameters['ngbActiveModal']) this.ngbActiveModal = customParameters['ngbActiveModal'];
        if (customParameters['modalService']) this.modalService = customParameters['modalService'];
        if (customParameters['dialogService']) this.dialogService = customParameters['dialogService'];
        if (customParameters['apiService']) this.apiService = customParameters['apiService'];
        if (customParameters['messagingService']) this.messagingService = customParameters['messagingService'];
        if (customParameters['adminService']) this.adminService = customParameters['adminService'];
    }

    //#region properties
    public datatable_view: string;
    public root_css_class: string;
    public data_table_loading_message: string = 'Loading Data...';
    public data_items: Array<any> = [];
    public filtered_data_items: Array<any> = [];
    public cur_page_data_items: Array<any> = [];
    // public columnFields: Array<any> = [];
    public visibleColumnFields: ViewColumnField[] = [];
    public formulaColumnFields: Array<any> = [];
    public data_items_loaded: boolean = false;
    public current_filtered_values: any = {}
    public is_group_label_enabled: boolean = false;

    public table_view_config: TableViewConfig = new TableViewConfig();

    // private viewConditions: Array<any> = [];
    // private viewFormulas: Array<any> = [];
    // public columnGroups: any[] = [];
    public visible_column_groups: any = [];
    public pageFilterFields: Array<any> = [];
    public current_user: User;
    // paging 
    public curPage: number = 1;
    public pageSize: number = 50;
    public pageCount: number = 0;
    public itemCount: number = 0;
    public order_by_field: string = 'total_weighted_pct';
    public order_by_direction: string = 'desc';
    public asc: boolean = false;
    protected conditionResults: Array<Condition> = [];
    public header_style: any = { 'font-size': '12px', 'font-weight': 'bold', 'color': 'white', 'text-align': 'center' }
    //#endregion
    public is_disposed: boolean = false;
    public server_side_data_filter_tracker: any = {}
    public server_side_data_filter:any = {}

    //#region Page View logic
    getDataTableView() { return this.datatable_view; }

    public initialize(): void {
        this.current_user = this.authService.getAuth();
        this.loadTableViewMetaData();
    }

    public dispose() {
        this.is_disposed = true;
    }

    loadFilter(field) {
        var filter = field.key;
        if (this.server_side_data_filter_tracker && this.server_side_data_filter_tracker[filter] != 'loaded' && this.server_side_data_filter_tracker[filter] != 'loading') {
            this.sessionService.log("loading filter: " + filter);
            this.server_side_data_filter_tracker[filter] = 'loading';
            field.filter_data = [];
            this.loadFilterMetaData(field);
        }
    }

    isFilterLoading(field) {
        return this.server_side_data_filter_tracker[field.key] != 'loaded';
    }

    // load metadata for the current view, should only need to load on initialization
    loadFilterMetaData(field) {
        var params = this.getSearchParams();
        var filters = JSON.parse(params.f);
        params.return_filter = field.key;
        this.metadataService.getTableViewMetaData(this.datatable_view, params, true).subscribe(result => {
            var column_fields = this.table_view_config.column_fields.find(f => f.key == field.key);
            column_fields.filter_data = result.meta_data.data_filter[field.key];
            this.server_side_data_filter[field.key] = result.meta_data.data_filter[field.key];
            this.server_side_data_filter_tracker[field.key] = 'loaded';
            this.sessionService.log(field.key, this.server_side_data_filter[field.key]);
        });
    }

    protected loadTableViewMetaData(): void {
        this.data_items_loaded = false;
        this.visibleColumnFields = [];
        var view = this.getDataTableView();
        var table_view_config = new TableViewConfig();
        this.metadataService.getTableViewMetaData(view, { }, true).subscribe(result => {
            Object.assign(table_view_config, result.meta_data);
            this.table_view_config = table_view_config;
            this.pageSize = result.meta_data.view_settings && result.meta_data.view_settings.page_size > 0 ? result.meta_data.view_settings.page_size : 50;
            this.order_by_field = result.meta_data.view_settings && result.meta_data.view_settings.order_by_field ? result.meta_data.view_settings.order_by_field : 'u.user_ID';
            this.order_by_direction = result.meta_data.view_settings && result.meta_data.view_settings.order_by_direction ? result.meta_data.view_settings.order_by_direction : 'desc';

            this.formulaColumnFields = [];
            this.table_view_config.column_fields.forEach(f => {
                if (f.sn_calc_formula && f.sn_calc_formula.length > 0) {
                    this.formulaColumnFields.push(f);
                }
            })

            // load view items here after meta data is downloaded
            this.reloadItems();
        });
    }

    public reloadItems(init_filter_fields: boolean = true): void {
        if (this.is_loading_data) return;
        this.is_loading_data = true;
        // reset state variable before reloading action plans
        this.pageFilterFields = [];
        if (init_filter_fields && this.isClientsideFilteringEnforced()) this.current_filtered_values = {};

        var data_items = this.getDetailItems(init_filter_fields);
        // certain views need to query db to get the data_items, thus not all views returns data_items immediately.
        // for those that does, we can processDetailItems right away. 
        // for those that doesn't, it is up that view to processDetailItems once the data_items are available.
        if (data_items) {
            this.is_loading_data = false;
            this.processDataItems(data_items, init_filter_fields);
        }
    }

    public getDetailItems(init_filter_fields: boolean): any {
        this.is_loading_data = false;
        return null;
    }

    protected isClientsideFilteringEnforced() {
        return this.table_view_config && this.table_view_config.view_settings && this.table_view_config.view_settings.enforce_clientside_filtering;
    }

    public processDataItems(data_items, init_clientside_filter_fields: boolean) {
        this.data_items = data_items;
        this.filtered_data_items = this.data_items;
        this.data_items_loaded = true;
        if (!this.isClientsideFilteringEnforced()) init_clientside_filter_fields = false;

        this.data_items.forEach(item => {
            // process all conditions for each item
            if (this.table_view_config.view_conditions) {
                var conditions = JSON.parse(JSON.stringify(this.table_view_config.view_conditions));
                item.viewConditions = this.conditionService.evaluateItemValues(conditions, null, item);
            }
            if (this.table_view_config.view_formulas) {
                var formula_results = this.formulaService.calculateFormulaValuesByItem(this.table_view_config.view_formulas, item);
                item.formula_results = formula_results;
                this.formulaColumnFields.forEach(f => {
                    var fr = formula_results.find(r => r.name == f.sn_calc_formula);
                    if (fr) item[f.key] = fr.result;
                })
            }
        });

        // extract all visible columns
        this.visibleColumnFields = [];
        this.table_view_config.column_fields.forEach(cf => {
            if (cf.visible) {
                var bVisible = true;
                if (cf.sn_column_visible) {
                    if (cf.sn_column_visible.indexOf('@{') >= 0) {
                        var local_condition = cf.sn_column_visible.replace('@{', '').replace('}', '');
                        bVisible = this[local_condition];
                    } else {
                        var condResult = this.conditionService.getCondition(this.data_items[0].viewConditions, cf.sn_column_visible);
                        bVisible = condResult ? condResult.result : true;
                    }
                }
                if (bVisible) this.visibleColumnFields.push(cf);
            }

            if (cf.sn_enable_filtering && this.data_items.length > 0) {
                var condResult = this.conditionService.getCondition(this.data_items[0].viewConditions, cf.sn_enable_filtering);
                cf.enable_filtering = condResult ? condResult.result : cf.enable_filtering;
            }
            if (cf.is_page_filter && cf.enable_filtering) this.pageFilterFields.push(cf);
        })

        this.visible_column_groups = [];

        // from visible columns, pre-construct grouping <td>
        if (this.visibleColumnFields.find(f => f.group_label != null && f.group_label.length > 0) != null) this.is_group_label_enabled = true;
        if (this.is_group_label_enabled) {
            this.visible_column_groups = [];
            for (var i = 0; i < this.visibleColumnFields.length; i++) {
                var curr_field = this.visibleColumnFields[i];
                var curr_group_label = curr_field.group_label ? curr_field.group_label : '';
                var vg = this.visible_column_groups.find(cg => cg.label == curr_group_label);
                var cg = this.table_view_config.column_groups ? this.table_view_config.column_groups.find(cg => cg.label == curr_group_label) : null;
                if (cg) {
                    if (vg == null) {
                        // find the group definition
                        vg = JSON.parse(JSON.stringify(cg));
                        vg.colspan = 1;
                        vg.class = curr_field.cell_class;
                        //g = { label: curr_group_label, colspan: 1, class: curr_field.cell_class }
                        this.visible_column_groups.push(vg);
                    } else {
                        vg.colspan++;
                    }
                }
            }
        }

        this.generateFilterData();
        if (init_clientside_filter_fields) this.initPageFilterFieldSelections();

        // this.curPage = 1;
        this.updateClientSideDisplayDetailedItems();
    }

    public initPageFilterFieldSelections() {
    }
    //#endregion

    //#region methods
    public showLoadingMessage(): boolean {
        return !this.data_items_loaded;
    }

    public getLoadingMessage(): string {
        return this.data_table_loading_message;
    }

    public isDataTableReady(): boolean {
        return this.data_items_loaded;
    }

    public isGroupLabelEnabled(): boolean {
        return this.is_group_label_enabled;
    }

    public getColumnGroups(): ViewColumnGroup[] {
        return this.table_view_config.column_groups;
    }

    public getViewConditions(): ViewCondition[] {
        return this.table_view_config.view_conditions;
    }

    public getViewFormulas(): ViewFormula[] {
        return this.table_view_config.view_formulas;
    }

    public getVisibleColumnFields(): ViewColumnField[] {
        return this.visibleColumnFields;
    }

    public isPagingEnabled(): boolean {
        return true;
    }

    public getNoDataMessage(): string {
        return "No Data Found";
    }

    public isAllowEdit(item: any, field: ViewColumnField) {
        if (field.sn_allow_edit) {
            var condResult = this.conditionService.getCondition(item.viewConditions, field.sn_allow_edit);
            return condResult ? condResult.result : true;
        }
        return field.allow_edit;
    }

    public isValueVisible(item: any, field: ViewColumnField) {
        switch (field.display_type) {
            case ViewConfig.DT_Url:
            case ViewConfig.DT_ImageUrl:
                var value = this.getFieldValue(item, field);
                return (value && value.length > 0);
        }
        return true;
    }

    public isBtnVisible(btn: ViewButton, item: any, field: ViewColumnField) {
        if (item && item.viewConditions) {
            var condResult = this.conditionService.getCondition(item.viewConditions, btn.sn_visible);
            return condResult ? condResult.result : true;
        }
        return true;
    }

    public onBtnClick(btn: ViewButton, item: any, field: ViewColumnField) {
        console.log("onBtnClick::" + btn.event);
    }

    public isUrlField(field: ViewColumnField): boolean { return field && field.display_type == ViewConfig.DT_Url || field.display_type == ViewConfig.DT_ImageUrl; }
    public isTextUrlField(field: ViewColumnField): boolean { return field && field.display_type == ViewConfig.DT_Url; }
    public isImageUrlField(field: ViewColumnField): boolean { return field && field.display_type == ViewConfig.DT_ImageUrl; }
    public isValueField(field: ViewColumnField): boolean { return field && !this.isCellToggle(field) && !this.isImageButton(field) && !this.isUrlField(field); }
    public isCellToggle(field: ViewColumnField): boolean { return field && field.display_type == ViewConfig.DT_CellToggle; }
    public isImageButton(field: ViewColumnField): boolean { return field && field.display_type == ViewConfig.DT_ImageButton; }
    public isImageIcon(btn: ViewImageButton) { return (btn.button_type == "IMG"); }
    public isFontAwesomeIcon(btn: ViewImageButton) { return (btn.button_type != "IMG"); }


    getExecuteScriptType(bSearchData: boolean = true, bTotalCount: boolean = true) {
        if (bSearchData && bTotalCount) return "ST_All";
        if (bSearchData) return "ST_Search";
        if (bTotalCount) return "ST_TotalCount";
    }

    // gather all search params in json format to be used as request string parameter
    getSearchParams(executeScriptType: string = null, filters: any[] = null) {
        var params: any = {}
        params.p = this.curPage;
        params.ps = this.pageSize;
        params.ob = this.order_by_field;
        params.obd = this.asc ? "asc" : "desc";
        if (this.order_by_direction != null) params.obd = this.order_by_direction;
        if (executeScriptType) params.est = executeScriptType;
        if (filters == null) filters = this.getCurrentServerSideFilters();
        params.f = JSON.stringify(filters);
        return params;
    }

    getCurrentServerSideFilters() {
        var filters = [ ];
        var default_filters = this.table_view_config.default_filters;
        for (var field_key in default_filters) {
            var default_filter = default_filters[field_key];
            var field = this.table_view_config.column_fields.find(f => f.key == field_key);
            // on initial search, there would not have a filtered_value, thus use the default_filter.value
            filters.push({ field: field_key, op: default_filters[field_key].op, value: field.current_filtered_value != null ? field.current_filtered_value : default_filter.value });  // op defined in view config
        }
        return filters;
    }

    public getFilteredDataItem(): any[] {
        return this.filtered_data_items;
    }

    public generateFilterData() {
        if (this.isClientsideFilteringEnforced()) {
            this.table_view_config.column_fields.forEach(f => {
                if (f.enable_filtering && (f.filter_data == null || f.is_dataset_dependent_filter != false)) f.filter_data = this.getDataFilter(f);
            })
        }
    }

    public getDataFilter(field: ViewColumnField) {
        var filter_list = !field.allow_all_as_filter_value ? [] : [{ label: 'All', value: '' }];
        if (this.data_items_loaded && field.enable_filtering) {
            if (field.filter_data_source == 'data') {
                this.filtered_data_items.forEach(ap => {
                    var field_value = this.getFieldValue(ap, field);
                    var filter = filter_list.find(f => f.value == field_value);
                    if (filter == null) {
                        var field_label = this.getFieldFilterDisplay(ap, field);
                        filter_list.push({ label: field_label, value: field_value });
                    }
                })
            }

            filter_list.sort(function (a, b) {
                var sort_order = -1; // default: ascending order
                if (field.filter_value_sort_order == 'desc') sort_order = 1;
                return (a.value < b.value) ? sort_order : sort_order * -1;
            })
        }
        return filter_list;
    }

    public getFieldFilterDisplay(item: any, field: ViewColumnField): any {
        if (item && field) {
            return this.getFieldValue(item, field);
        }
        return null;
    }

    public showFilteredValue(field: ViewColumnField): boolean {
        if (field.is_page_filter && field.allow_all_as_filter_value && (field.current_filtered_value == null || field.current_filtered_value == "")) return true;
        return (field && field.current_filtered_value);
    }

    public getFilteredValue(field: ViewColumnField) {
        var default_filter = this.table_view_config.default_filters[field.key];
        var all_label = default_filter && default_filter.all_label ? default_filter.all_label : 'All';
        if (field.is_page_filter && field.allow_all_as_filter_value && (field.current_filtered_value == null || field.current_filtered_value == "")) return all_label;
        return field.current_filtered_value;
    }

    public getFilteredValueLabel(field: ViewColumnField) {
        var default_filter = this.table_view_config.default_filters[field.key];
        var filter_data_item = field.filter_data.find(fd => fd.value == field.current_filtered_value);
        var all_label = default_filter && default_filter.all_label ? default_filter.all_label : 'All';
        if (field.is_page_filter && field.allow_all_as_filter_value && (field.current_filtered_value == null || field.current_filtered_value == "")) return all_label;
        return filter_data_item ? filter_data_item.label : "";
    }

    public filter(field: ViewColumnField, filter_item: any): void {
        var default_filter = this.table_view_config.default_filters[field.key];
        var all_label = default_filter && default_filter.all_label ? default_filter.all_label : 'All';
        field.current_filtered_value = (filter_item.value == all_label || filter_item.value == '') ? null : filter_item.value;
        // client-side filtering
        if (this.isClientsideFilteringEnforced()) {
            this.updateClientSideDisplayDetailedItems();
        } else {  // server-side filtering
            this.curPage = 1;
            for (var field_key in this.server_side_data_filter_tracker) {
                this.server_side_data_filter_tracker[field_key] = null; // reset to load filter data once again
            }
            this.reloadItems();
        }
    }

    public onSort(event: any, field: ViewColumnField) {
        this.curPage = 1;
        this.asc = (this.order_by_field == field.key) ? !this.asc : false;
        this.order_by_field = field.key;
        var sort_order = this.asc;
        // apply actual sort order
        this.filtered_data_items.sort(function (a, b) {
            var order = a[field.key] < b[field.key] ? -1 : 1;
            return sort_order ? order : order * -1;
        })

        this.updateCurrentPageDetailedItems();
    }

    public updateClientSideDisplayDetailedItems() {
        if (this.isClientsideFilteringEnforced()) {
            this.updateFilteredDetailedItems();
            this.pageCount = Math.ceil(this.filtered_data_items.length / this.pageSize);
            this.updateCurrentPageDetailedItems();
        }
    }

    public updateFilteredDetailedItems() {
        this.filtered_data_items = [];
        this.data_items.forEach(ap => {
            var bInclude = true;
            this.table_view_config.column_fields.forEach(f => {
                if ((f.enable_filtering || f.is_page_filter) && f.current_filtered_value) {
                    bInclude = bInclude && ap[f.key] == f.current_filtered_value;
                }
            })
            if (bInclude) this.filtered_data_items.push(ap);
        })
        this.generateFilterData();
    }

    public updateCurrentPageDetailedItems() {
        var item_index = (this.curPage - 1) * this.pageSize;
        this.cur_page_data_items = this.filtered_data_items.slice(item_index, item_index + this.pageSize);
    }

    public toggleCellValue(data_item: any, field: ViewColumnField) {
        if (data_item && field) {
            var field_value = data_item[field.key];
            data_item[field.key] = !field_value;            // toggle true and false
            this.processAutoSave();
        }
        console.log("toggle cell " + data_item[field.key].toString());
    }

    public getFieldValue(data_item: any, field: ViewColumnField): any {
        if (data_item && field) {
            var field_value = data_item[field.key];
            return field_value != null ? field_value : 0;
        }
        return null;
    }

    getFieldValueStyle(data_item: any, field: ViewColumnField) {
        var fvc = {};
        if (data_item && field) {
            var field_value = data_item[field.key];
        }
        return fvc;
    }

    public getColumnLabel(field: ViewColumnField): any {
        if (field) {
            var column_label = field.label;
            return column_label;
        }
        return "";
    }

    public getButtonTip(field: ViewColumnField, btn: ViewImageButton) {
        var btn_tip = btn.button_tip;
        return btn_tip;
    }

    public getCurrentPage(): number {
        return this.curPage;
    }

    public getPageCount(): number {
        return this.pageCount;
    }

    public nextPage(): number {
        return this.curPage;
    }

    public previousPage(): number {
        return this.curPage;
    }

    public showPreviousPage(): boolean {
        return this.curPage > 1;
    }

    public showNextPage(): boolean {
        return this.curPage >= 1 && this.curPage < this.pageCount;
    }

    public processAutoSave() {

    }
    //#endregion
}


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/adapters/datatable.adapter.ts